import React, { Component } from "react";
import { Grid, List, ListItem } from "@material-ui/core";
import * as QueryString from "query-string";
import { NotificationManager } from "react-notifications";
import Header from "../../components/Header";
import { primaryColor, textPrimary, webFont } from "../../config/theme";
import ReviewEngagement from "../../components/ChefBooking/ReviewEngagement";
import DinersKitchen from "../../components/ChefBooking/DinersKitchen";
import BookingConfirmation from "../../components/ChefBooking/Confirmation";
import Breadcrumbs from "../../components/Breadcrumbs";

import Button from "@material-ui/core/Button/Button";
import connect from "react-redux/es/connect/connect";
import { compose, graphql } from "react-apollo";
import { UPDATE_BOOKING } from "../../graphql/mutations/booking";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import { USER_PROFILE } from "../../graphql/queries/user";
import { getCurrentBooking } from "../../redux/chefs";

class Booking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: [
        {
          header: "STEP 1",
          text: "Review engagement",
          id: 1
        },
        {
          header: "STEP 2",
          text: "Diner’s kitchen",
          id: 2
        },
        {
          header: "STEP 3",
          text: "Booking confirmation",
          id: 3
        }
      ],
      step: 1,
      loading: false,
      message: "",
      isScheduleScreen: false,
    };
  }
  componentDidMount() {
    this.props.dispatch(getCurrentBooking());

    const { search } = this.props.location;
    if (search === '?ps=schedule') {
      this.setState({ isScheduleScreen: true });
    }
  }

  updateChefBooking = data => {
    const { updateBooking } = this.props;
    this.setState({ loading: true });
    updateBooking({
      variables: data.payload
    })
      .then(res => {
        this.setState({ loading: false }, () => {
          this.props.history.push("/home/chef-bookings?step=1");
        });
      })
      .catch(err => {
        const error = JSON.parse(JSON.stringify(err))
        if (error.message) {
          if (error.message.startsWith('GraphQL error:')) {

            const msg = error.message.substr(15);
            NotificationManager.error(msg, 'Booking', 4000);
          }
        }
        this.setState({ loading: false });
      });
  };
  render() {
    const { steps, isScheduleScreen } = this.state;
    const { location, booking, userDetails } = this.props;

    if (!booking) {
      this.props.history.push("/home/chef-bookings");
    }
    const parsed = QueryString.parse(location.search);
    let step = 1;
    if (parsed) {
      step = parsed.step ? parseInt(parsed.step) : 1;
    }

    const childRoutes = [];
    if (!isScheduleScreen) {
      childRoutes.push({
        display: 'Bookings',
        link: 'home/chef-bookings?step=1'
      });
    } else {
      childRoutes.push({
        display: 'Schedule',
        link: 'home/chef-schedule?option=2'
      });
    }

    childRoutes.push({
      display: 'Review Engagement',
      link: ''
    });

    return (
      <>
        <Grid container>
          <Grid item xs={12}>
            <Header history={this.props.history} loading={this.state.loading} />
          </Grid>
        </Grid>
        <Grid container className="review-management-container">
          <div style={{ marginBottom: 15, width: '100%', display: 'flex' }}>
            <Breadcrumbs childRoutes={childRoutes} />
          </div>
          <Grid className="review-management-leftcol">
            <List className="review-management-list">
              {steps.map(item => (
                <ListItem
                  key={item.id}
                  button
                  onClick={() => this.props.history.push("?step=" + item.id)}
                  style={{ ...style.itemStyle, ...style.textFont }}
                >
                  <div>
                    <p
                      style={
                        step <= item.id
                          ? style.stepNumber
                          : style.stepNumberUnselected
                      }
                    >
                      {item.header}
                    </p>
                    <p
                      style={
                        step === item.id
                          ? style.stepSelected
                          : item.id < step
                          ? style.stepText
                          : style.stepUnselected
                      }
                    >
                      {item.text}
                    </p>
                  </div>
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid className="review-management-rightcol">
            {step === 1 && (
              <ReviewEngagement
                booking={booking}
                userDetails={userDetails}
                onMessageUpdate={msg => this.setState({ message: msg })}
              />
            )}
            {step === 2 && <DinersKitchen booking={booking} userDetails={userDetails} />}
            {step === 3 && (
              <BookingConfirmation
                booking={booking}
                history={this.props.history}
                isChef={this.props.isChef}
                onClick={payload =>
                  this.updateChefBooking({
                    payload,
                    message: this.state.message
                  })
                }
              />
            )}
          </Grid>

          <Grid item md={2} sm={12} style={{ display: "flex", alignItems: "flex-end", marginBottom: 15, }}>
            <Grid
              container
              direction={"column"}
              style={{ display: "flex", alignItems: "flex-end" }}
            >
              {step !== 3 && (
                <Grid item md={12} sm={12}>
                  <Button
                  data-test-id={"review-next"}
                    variant={"contained"}
                    color={"primary"}
                    style={style.nextButton}
                    onClick={() => this.props.history.push("?step=" + (step + 1))}
                  >
                    {"Next"}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
}
const style = {
  itemStyle: {
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
    borderBottom: "1px solid lightgray"
  },
  stepNumber: {
    opacity: 0.4,
    fontSize: 14,
    fontFamily: webFont,
    color: '#000000',
    margin: 0,
    fontWeight: 500,
  },
  stepText: {
    fontSize: 17,
    fontWeight: 500,
    color: primaryColor,
    fontFamily: webFont,
    margin: '5px 0 16px',
    lineHeight: 'normal',
  },
  stepSelected: {
    fontSize: 17,
    fontWeight: 500,
    color: "#000000",
    fontFamily: webFont,
    margin: '5px 0 16px',
    lineHeight: 'normal',
  },
  stepNumberUnselected: {
    fontSize: 14,
    color: primaryColor,
    fontFamily: webFont,
    fontWeight: 500,
    margin: 0,
  },
  stepUnselected: {
    opacity: 0.3,
    fontSize: 17,
    fontWeight: 500,
    color: "#000000",
    fontFamily: webFont,
    margin: '5px 0 16px',
    lineHeight: 'normal',
  },
  textFont: {
    fontFamily: webFont
  },
  nextButton: {
    width: 204,
    height: 49,
    borderRadius: "45.5px",
    fontSize: 18,
    color: "white",
    textTransform: "none",
    fontFamily: webFont,
    marginTop: 20,
    boxShadow: 'none',
    fontWeight: 'normal',
  }
};

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    booking: state.chefs.currentBooking
  };
};
const BookingWithData = compose(
  graphql(UPDATE_BOOKING, {
    name: "updateBooking"
  }),
  graphql(USER_PROFILE, {
    name: "userDetails",
    options: props => ({
      variables: {
        userId: props.booking && props.booking.userId
      }
    })
  })
)(Booking);

const ChefBooking = connect(mapStateToProps)(BookingWithData);
export default ChefBooking;
